import { taxTabs } from "./tax-tabs";
import { components } from "./components";
import { newPageNotificationModal } from "./new-page-notification-modal";

export const fiscalData = {
	components,
	taxTabs,
	newPageNotificationModal,
	titlePage: "Datos Fiscales",
	titlesTabs: {
		taxCouvert: "Datos fiscales de cover",
		taxGroups: "Grupos fiscales de producto",
		taxProfiles: "Perfiles fiscales",
		minimumConsummation: "Consumo mínimo",
		recharge: "Recarga",
	},
};
